import Marquee from "react-fast-marquee";

const items = [
  "SCE-HR+ Anti Moisture",
  "SCE-DM Desiccant Masterbatch",
  "SCE-QL Quick Lime",
  "SCE-CF Calcium Filler",
  "SCE-CMB Colour Masterbatch",
  "Made in Bhiwadi",
  "Est. Rajasthan",
];

const Divider = () => (
  <span
    aria-hidden
    className="inline-block mx-8 lg:mx-14 w-2 h-2 rotate-45 bg-[#C6F035] align-middle"
  />
);

const EditorialMarquee = () => {
  return (
    <section
      className="w-full py-8 border-y border-[#0A2A1E]/15 bg-[#faf9f6] overflow-hidden"
      aria-label="Product marquee"
    >
      <Marquee speed={40} gradient={false} pauseOnHover>
        <div className="flex items-center">
          {items.concat(items).map((t, i) => (
            <span key={i} className="flex items-center">
              <span className="font-display text-[#0A2A1E] text-5xl md:text-6xl leading-none whitespace-nowrap">
                {t.split(" ")[0]}{" "}
                <span className="font-display-italic">
                  {t.split(" ").slice(1).join(" ")}
                </span>
              </span>
              <Divider />
            </span>
          ))}
        </div>
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
